import * as React from 'react';

interface OverlayContextValue {
  /** Container element for dialogs to portal into */
  container: HTMLElement | null;
}

const OverlayContext = React.createContext<OverlayContextValue>({ container: null });

export function OverlayProvider({ container, children }: { container: HTMLElement | null; children: React.ReactNode }) {
  const value = React.useMemo(() => ({ container }), [container]);
  return <OverlayContext.Provider value={value}>{children}</OverlayContext.Provider>;
}

/**
 * Hook to get the overlay container for constraining modals.
 * Returns null if not inside an overlay, which means modals will portal to body.
 */
export function useOverlayContainer(): HTMLElement | null {
  return React.useContext(OverlayContext).container;
}
